import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'crm-button-show-and-hide',
  templateUrl: './button-show-and-hide.component.html',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonShowAndHideComponent {
  @Input() public isShow = true;
  @Output() public isShowChange = new EventEmitter<boolean>();
}
